import {
  TOpenSourceLicense,
} from './table-open-source-licenses.ts';

const licenseColumn: Record<keyof TOpenSourceLicense, string> = {
  name: 'Library / Project',
  version: 'Version',
  license: 'License',
  url: 'Homepage',
  notice: 'License Text',
  notice_url: 'License URL',
  package_url: 'URL on package index',
};

export default {
  licenseColumn,
};
